import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { UserForm } from '@/modules/users/components/UserForm'
import { useUserMutation } from '@/modules/users/hooks/useUserMutation'

export function UserCreatePage() {
  const { create, isSubmitting, error } = useUserMutation()

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Link to="/users" className="text-gray-500 hover:text-gray-700">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">Nuevo Vendedor</h1>
      </div>
      <div className="card p-6">
        <UserForm
          mode="create"
          onSubmit={create}
          isSubmitting={isSubmitting}
          submitLabel="Crear Vendedor"
          error={error}
        />
      </div>
    </div>
  )
}
